var React = require('react');

function SauceIconHeart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M50 40h20L60 60H40l10-20ZM40 60h20L50 80H30l10-20ZM60 20h20L70 40H50l10-20ZM20 20H0l10 20h20L20 20ZM30 40H10l10 20h20L30 40Z","fill":"#3DDC91","key":0}),React.createElement("path",{"d":"M40 60H20l10 20h20L40 60Z","fill":"#3DDC91","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 20h20V0C8.952 0 0 8.952 0 20ZM40 20h20V0C48.952 0 40 8.952 40 20ZM20 0v20h20C40 8.952 31.048 0 20 0ZM60 0v20h20C80 8.952 71.048 0 60 0Z","fill":"#3DDC91","key":2})]);
}

SauceIconHeart.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = SauceIconHeart;

SauceIconHeart.default = SauceIconHeart;
